// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-3_slH";
var _3 = "aircraftModal__root-1vxAW";
var _4 = "dates-1AXlc";
var _5 = "date-1rPW8";
var _6 = "segment_filled-2xiP3";
var _7 = "date_nextDayArrival-3bAeZ";
var _8 = "timeEnRoute-3hYrT";
var _9 = "timeEnRoute_text-3rHWB";
var _a = "short-2RnMl";
var _b = "airports-BHXDw";
var _c = "airport-DKSEB";
var _d = "airport__city-1ex-a";
var _e = "airport__name-oRbtg";
var _f = "airport__terminal-3z8g0";
var _10 = "details-3xnVe";
var _11 = "details__summary-Yf9Ux";
var _12 = "details__logo-kdPgz";
var _13 = "details__eco-2t4V6";
var _14 = "details__short-boFzM";
var _15 = "details__arrow-39dYG";
var _16 = "opened-306O3";
var _17 = "details__full-3KCLX";
var _18 = "statistics-3mByP";
var _19 = "statistics__item-26aHv";
var _1a = "statistics__item__title-nB_GH";
var _1b = "statistics__item__value-2lB6k";
var _1c = "aircraft-n0m7Q";
var _1d = "aircraft__name-1CPTw";
var _1e = "aircraft__image-1O8B5";
var _1f = "aircraft__features-2zCDD";
var _20 = "aircraft__features__moreInfo-25z84";
var _21 = "airport__info__name-P1W1T";
var _22 = "airport__info-3WKTG";
var _23 = "airport__info__image-3seUt";
var _24 = "airport__info__icon-3I_gP";
var _25 = "weather-1g4Jx";
var _26 = "weather__value-l0hr2";
var _27 = "weather__icon-3ypn-";
export { _1 as "__esModule", _2 as "segment", _3 as "aircraftModal__root", _4 as "dates", _5 as "date", _6 as "segment_filled", _7 as "date_nextDayArrival", _8 as "timeEnRoute", _9 as "timeEnRoute_text", _a as "short", _b as "airports", _c as "airport", _d as "airport__city", _e as "airport__name", _f as "airport__terminal", _10 as "details", _11 as "details__summary", _12 as "details__logo", _13 as "details__eco", _14 as "details__short", _15 as "details__arrow", _16 as "opened", _17 as "details__full", _18 as "statistics", _19 as "statistics__item", _1a as "statistics__item__title", _1b as "statistics__item__value", _1c as "aircraft", _1d as "aircraft__name", _1e as "aircraft__image", _1f as "aircraft__features", _20 as "aircraft__features__moreInfo", _21 as "airport__info__name", _22 as "airport__info", _23 as "airport__info__image", _24 as "airport__info__icon", _25 as "weather", _26 as "weather__value", _27 as "weather__icon" }
export default { "__esModule": _1, "segment": _2, "aircraftModal__root": _3, "dates": _4, "date": _5, "segment_filled": _6, "date_nextDayArrival": _7, "timeEnRoute": _8, "timeEnRoute_text": _9, "short": _a, "airports": _b, "airport": _c, "airport__city": _d, "airport__name": _e, "airport__terminal": _f, "details": _10, "details__summary": _11, "details__logo": _12, "details__eco": _13, "details__short": _14, "details__arrow": _15, "opened": _16, "details__full": _17, "statistics": _18, "statistics__item": _19, "statistics__item__title": _1a, "statistics__item__value": _1b, "aircraft": _1c, "aircraft__name": _1d, "aircraft__image": _1e, "aircraft__features": _1f, "aircraft__features__moreInfo": _20, "airport__info__name": _21, "airport__info": _22, "airport__info__image": _23, "airport__info__icon": _24, "weather": _25, "weather__value": _26, "weather__icon": _27 }
